import React, { useEffect, useState } from 'react';
import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';
import isBrowser from '~/utils/is-browser';
import isEmpty from '~/utils/valid/is-empty';
import ga from '~/utils/ga';
import dabangBridge from '~/utils/bridge';
import bridge from '~/utils/pro-bridge';

import MainInputContainer from './containers/MainInputContainer';
import CheckContainer from './containers/CheckContainer';

import { BGWrap, CheckSection, ButtonWrapper, ButtonImg } from './styled'; 

import section_top from './assets/section_top.png';
import section_mainInfo_bg from './assets/section_mainInfo_bg.png';
import section_check_info1 from './assets/section_check_info1.png';
import section_check_info2 from './assets/section_check_info2.png';
import footer from './assets/footer.png';
import btn_back from './assets/btn_back.png';
import btn_submit from './assets/btn_submit.png'

const CescoApply = () => {
  const host = process.env.NODE_ENV === 'development' ? TEST_URL : LIVE_URL
  const sessionAuthKey = isBrowser() && sessionStorage.getItem('authKey');
    
  useEffect(() => {
    if (sessionAuthKey) {
      getApplyInfo(sessionAuthKey);
    } else {
      alert('올바른 경로로 접근해주세요');
      window.location.replace('/2022/06/cescoMain');
    }
  }, [sessionAuthKey])

  const [ state, setState ] = useState({
    //신규인지 아닌지 판단
    type: '',
    name: '',
    phone: '',
    date: '',
    address: '',
    roomSizeType: '',
    checkType1 : false,
    checkType2 : false
  })

const getApplyInfo = async authKey => {
  try {
    const { result, code } = await apiCall.get(`${host}/api/v1/event/2022/cesco`, { authKey });
  
    if (code === 200) {
      const { name, phone, date, address, roomSizeType, type } = result;
      return setState(prev => ({
        ...prev,
        name,
        phone:phone.replace(/-/g, ''),
        date: isEmpty(date) ? '' : date,
        address: isEmpty(address) ? '' : address,
        roomSizeType: isEmpty(roomSizeType) ? '' : roomSizeType,
        type,
      }));
    }

    alert('올바른 경로로 접근해주세요');
    window.location.replace('/2022/06/cescoMain');
  } catch (err) {
    console.log(err);
    alert(err?.msg ?? '서버에러가 발생했습니다.');
  }
}

const onClickPrevHandler = () => {
  const result = window.confirm(`입력한 정보가 초기화될 수 있습니다.\n이전 페이지로 이동하시겠습니까?`)
  if (result) {
    ga('다방X세스코 제휴이벤트', '페이지 이동', '페이지 뒤로가기');
    window.location.href = '/2022/06/cescoMain';
  }
}

const onClickSubmitHandler = async () => {
  ga('다방X세스코 제휴이벤트', '제출하기', '최종 제출 하기');

  const { date, address, roomSizeType, checkType1, checkType2 } = state

  if (checkType1 === false || checkType2 === false) return alert('본 이벤트는 정보입력 및 개인정보 수집/이용 항목에 동의 후 참여가능 합니다.');
  if (date === '') return alert('신청날짜를 선택해주세요.');
  if (address === '') return alert('신청지역을 입력해주세요.');
  if (roomSizeType === '') return alert('젼용면적을 선택해주세요.');

  try {
    const tempData = {
      authKey: sessionAuthKey,
      date,
      address,
      roomSizeType,
    };

    const { code } = await apiCall.post(`${host}/api/v1/event/2022/cesco`, tempData);
    
    if (code === 200) {   
      alert('이벤트 정상 신청되었습니다.');
      bridge.android(call => {
        call.finishActivity();
      });
      dabangBridge.ios(call => {
        call.callHandler('ObjC Echo', {
          cmd: 'finishActivity',
        });
      });
      window.close()
    }
  } catch (err) {
    console.log(err);
    alert(err?.msg ?? '서버에러가 발생했습니다.');
  }
}

return (
    <div>
      <BGWrap width={640} height={482} imgUrl={section_top} />
      <BGWrap width={640} height={513} imgUrl={section_mainInfo_bg}>
        <MainInputContainer state={state} setState={setState} />
      </BGWrap>
      <CheckSection>
        <CheckContainer 
          Type = {'Type1'}
          imgUrl={section_check_info1}
          setState={setState}
          isChecked={state.checkType1}
        />
        <CheckContainer 
          Type = {'Type2'}
          imgUrl={section_check_info2}             
          setState={setState} 
          isChecked={state.checkType2}
        />
        <ButtonWrapper style={{display:'flex', justifyContent:'center'}}>
          <ButtonImg className='prev' onClick={onClickPrevHandler} src= {btn_back} />
          <ButtonImg src= {btn_submit} onClick={onClickSubmitHandler} />
        </ButtonWrapper>      
      </CheckSection>
      <BGWrap width={640} height={285} imgUrl={footer} />     
    </div>
  );
};

export default CescoApply
